<template>
  <div>
    <v-app-bar app color="blue" elevation="5" height="45">
      <v-tabs color="white" grow v-model="tab">
        <v-tabs-slider color="yellow" />
        <v-tab :to="path_toDraw" @click="onNav('draw', $event)">{{ $t('nav.draw') }}
          <v-icon>mdi-brush</v-icon>
        </v-tab>
        <v-tab :to="path_toList" @click="onNav('catalog', $event)">{{ $t('nav.catalog') }}
          <v-icon>mdi-penguin</v-icon>
        </v-tab>
        <v-tab :to="path_toForm" value="first" @click="onNav('home', $event)">{{ $t('nav.home') }}
          <v-icon>mdi-account</v-icon>
        </v-tab>
      </v-tabs>
    </v-app-bar>
  </div>
</template>

<script>
// import Drawing from "./drawing.vue";
import { fire } from '@/utils/logger';

export default {
  props: ['aquarium'],
  name: "HeaderNav",

  data: () => ({
    // tab: `/${this.$store.state.aquarium}/form`,
    tab: 'first',  //初期値のセット
    _lastFireAt: 0, // 連打ガード用
  }),
  methods: {
    onNav(toScreen, e) {
      // 中クリックや Cmd/Ctrl+クリック（別タブ遷移）は記録しない
      if (e && (e.button === 1 || e.metaKey || e.ctrlKey)) return;

      // 連打ガード（100ms）
      const now = performance.now();
      if (now - this._lastFireAt < 100) return;
      this._lastFireAt = now;

      // from は基本 last_screen（= getPrevScreen）から。
      // もし未設定なら現在のパスから推定。
      // let fromScreen = getPrevScreen();
      // console.log('fromScreen:', fromScreen);
      // if (fromScreen === 'direct' || fromScreen === 'external') {
      //   fromScreen = mapScreenByPath(this.$route?.path || location.pathname);
      // }

      fire('nav_click',
        {
          // from: fromScreen,
          to: toScreen,
          source: 'header'
        });
      // 実際の遷移は :to が処理するので router.push は不要
      // setCurrentScreen(toScreen) は「到達した事実」ではないのでここでは呼ばない
      // （到達後は各画面の mounted で page_view → setCurrentScreen(screen) が走る）
    },
  },
  computed: {
    path_toForm() {
      return `/${this.$store.state.aquarium}/form`; // ダイナミックにパスを生成
    },
    path_toDraw() {
      return `/${this.$store.state.aquarium}/draw-penguin`; // ダイナミックにパスを生成
    },
    path_toList() {
      return `/${this.$store.state.aquarium}/list`;
    }
  }
};
</script>

<style scoped>
.custom-toolbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  /* 他のコンテンツの上に表示 */
}
</style>